import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Button, MessageBox } from "capitalrx-components";
import { queryString } from "capitalrx-utilities";

import PageContentLayout from "@/App/layouts/PageContent";
import { RootState } from "@/App/reducers";
import { drugsToQueryString, getDrugsFromQueryString } from "@/App/utils/utils";
import { DrugResult } from "@/types/appTypes/drug";

import ResultsTable from "./ResultsTable/ResultsTable";
import DrugSearchForm from "./SearchForm/SearchForm";
import SelectedDrugsTable from "./SelectedTable/SelectedDrugsTable";

import { logEvent, ANALYTIC_EVENTS } from "@/App/utils/analytics";

const DrugSearch: React.FC = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { selectedDrugs } = useSelector((state: RootState) => state.drug);
  const disableButton = !selectedDrugs.length;

  let noDrugSelectedDisplay = null;
  if (selectedDrugs.length === 0) {
    noDrugSelectedDisplay = (
      <MessageBox
        extraClasses={"caprx-h-center-text"}
        type="normal"
        message="Select a drug from the search results to add to your test claim. Add one for single and multiple for compound."
        shadow={false}
      />
    );
  }

  const handleAddClick = (): void => {
    // preserve the existing URL parameters
    const queryParams = queryString.getQueryParams(search);
    const originalDrugs = getDrugsFromQueryString(queryParams.drugs);
    const drugsWithQuantity = selectedDrugs.map((drug: DrugResult) => {
      for (const originalDrug of originalDrugs) {
        if (originalDrug.ndc === drug.ndc) {
          drug.quantity = originalDrug.quantity;
        }
      }
      return drug;
    });
    queryParams.drugs = drugsToQueryString(drugsWithQuantity);
    const paramsString = queryString.convertJsonToQueryString(queryParams);
    const finalPath = "/test-claim?" + paramsString;

    navigate(finalPath);

    logEvent(ANALYTIC_EVENTS.TEST_CLAIM_DRUG.addDrug);
  };

  return (
    <PageContentLayout title="Search for Drug" pageContentWrapperClassName="search-form-and-results-wrapper">
      <DrugSearchForm />
      <div className="mt30">
        <ResultsTable />
      </div>
      <div className="mt30">
        <SelectedDrugsTable />
      </div>
      {noDrugSelectedDisplay}
      <div className="drug-search-page-submit mt35">
        <Button buttonType="router" handleClick={handleAddClick} disabled={disableButton}>
          ADD DRUG(S)
        </Button>
      </div>
    </PageContentLayout>
  );
};

export default DrugSearch;
